'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Transport2 = require('./Transport');

var _Transport3 = _interopRequireDefault(_Transport2);

var _events = require('events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Consumer = function (_Transport) {
  _inherits(Consumer, _Transport);

  function Consumer(id, expectedOrigin, facade) {
    _classCallCheck(this, Consumer);

    var _this = _possibleConstructorReturn(this, (Consumer.__proto__ || Object.getPrototypeOf(Consumer)).call(this, id, expectedOrigin));

    var events = new _events2.default();
    events.setMaxListeners(0);
    _this.connectedWindow = window.opener || window.parent;
    _this.consumer = _this.facade = Object.assign(events, facade);
    _this.sendMessage({
      type: 'initialize',
      args: [_this.consumer],
      waitResponse: true
    }).then(function (_ref) {
      var result = _ref.response.result,
          responseToId = _ref.id;

      _this.provider = result[0];
      _this.sendMessage({ type: 'response', responseToId: responseToId });
      _this.emit('ready', _this.provider);
    });
    return _this;
  }

  return Consumer;
}(_Transport3.default);

exports.default = Consumer;